import { Hub } from '@/api/apis/facilities';
import { hubQueries } from '@/queries/hub';
import { queryClient } from '@/queries';

export const seedHubFromList = (hubs: Hub[] = []) => {
  hubs.forEach((hub) => {
    queryClient.setQueryData(hubQueries.item(hub.id).queryKey, hub);
  });
};
